import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import classnames from "classnames";
import IconColorize from "@mui/icons-material/Colorize";
import React from "react";

export interface IPixelInspect {
  className?: string;
  active: boolean;
  tooltip?: string;
  onClick: () => void;
}

const PixelInspectControl = ({
  className,
  active,
  tooltip,
  onClick,
}: IPixelInspect) => {
  return (
    <Tooltip title={tooltip || ""} placement="left">
      <Paper
        elevation={8}
        sx={{ textAlign: "center" }}
        className={classnames("marapp-qa-pixelinspectcontrol", className)}
      >
        <Button
          fullWidth
          onClick={onClick}
          color="secondary"
          // Same padding for both variants so the controls column keeps a
          // fixed width when toggling between text and contained
          sx={{ minWidth: "auto", padding: "4px 5px" }}
          size="small"
          variant={active ? "contained" : "text"}
        >
          <IconColorize fontSize="small" />
        </Button>
      </Paper>
    </Tooltip>
  );
};

export default PixelInspectControl;
